@if (infoService.validationErrorField) {
    <span
        >Check <strong>{{ infoService.validationErrorField }}</strong> for any of the following:</span
    >
}
@if (!infoService.validationErrorField) {
    <span>Check form fields for any of the following: </span>
}
<br /><br />
<ul style="list-style-type: none">
    <li>&lt;(any letter)</li>
    <li>&lt;!</li>
    <li>&lt;/</li>
    <li>&lt;?</li>
    <li>&amp;#</li>
</ul>
